import $axios from "../../api";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  warehouseList: "",
  isSuccess: false,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  WAREHOUSE_LIST(state, payload) {
    state.warehouseList = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
};

const actions = {
  getWarehouseList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `inv/warehouse/list?page=${state.page}&view=${rootState.Main.view
          }${payload ? payload : ""}`
        )
        .then((res) => {
          commit("WAREHOUSE_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          // dispatch("Main/globalSweetAlert", error.response, {
          //     root: true,
          // });
        });
    });
  },
  createWarehouse({ commit, state, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`inv/warehouse/create`, payload)
        .then((response) => {
          commit("SET_LOADING", false);
          commit("SET_SUCCESS", true);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          commit("SET_SUCCESS", false);
          // dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
  updateWarehouse({ commit, state, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .put(`inv/warehouse/update`, payload)
        .then((response) => {
          commit("SET_LOADING", false);
          commit("SET_SUCCESS", true);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          commit("SET_SUCCESS", false);
          // dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
  showhide({ commit, state, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .put(`inv/warehouse/showhide`, payload)
        .then((response) => {
          commit("SET_SUCCESS", true);
          dispatch('Main/globalSuccessSweetAlert', response.data.message, { root: true })
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
